export default __webpack_public_path__ + "static/media/c006-4.fc146716.jpg";